export const AUTO_SYNCED_ACCOUNT_LIMIT = 1000
